module.exports = __webpack_public_path__ + "static/Adieu-Regular-9132c98c3c2e5e63714733215216d885.otf";